import React from "react";
import { Link } from "react-router-dom";
import Avatar from "../Avatar";
import { singleClaimedRoomRoutes, singleRoomRoutes } from "../../routes";

function PopularRoomCard({ item, setCardHeight, setCardWidth, isCardSet }) {
  const conatinerRef = React.useRef();
  React.useEffect(() => {
    setTimeout(() => {
      const cardHeight = conatinerRef.current?.clientHeight;
      const cardWidth = conatinerRef.current?.clientWidth;
      if (
        cardHeight &&
        cardWidth &&
        setCardHeight &&
        setCardWidth &&
        !isCardSet
      ) {
        setCardHeight(cardHeight);
        setCardWidth(cardWidth);
      }
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const path = item?.slug
    ? singleClaimedRoomRoutes.path.replace(":slug", item.slug)
    : singleRoomRoutes.path.replace(":roomId", item._id);
  return (
    <Link to={path}>
      <div className="cardWidth flex flex-col space-y-1" ref={conatinerRef}>
        <div className="relative">
          <img
            alt="room"
            src={
              item.nft_logo_image || (item.cover ? item.cover?.urls?.small : "")
            }
            className="rounded-xl h-40 w-full object-cover"
            loading="lazy"
          />
        </div>
        <p className="font-medium text-navyGray dark:text-frescoWhite pt-1 text-base custom-line-clamp">
          {item.name}
        </p>
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="-space-x-4 flex overflow-hidden">
              {/* {item.user_avatars?.map((avatar, index) => (
                <div
                  className=" border-4 rounded-full dark:border-darkNight border-white"
                  key={index}
                >
                  <Avatar src={avatar} username="" size="xs" />
                 
                </div>
              ))} */}
              {item.users?.map((user, index) => (
                <div
                  className=" border-4 rounded-full dark:border-darkNight border-white"
                  key={index}
                >
                  <Avatar
                    src={user.profile_picture}
                    username={user.username}
                    size="xs"
                  />
                </div>
              ))}
              {/* <div className=" border-4 rounded-full dark:border-darkNight border-white">
                <div className="w-7 h-7 rounded-full">
                  <img
                    className="rounded-full w-full h-full"
                    alt="user1"
                    // src={avatar}
                    src="https://diamondapp.com/api/v0/get-single-profile-picture/BC1YLftoYzDAMK8fmHF3q8Vyeh6uX8sAYUk4PW12VxbpZ8bny5GvNe6" loading="lazy"
                  />
                </div>
              </div>
              <div className=" border-4 rounded-full dark:border-darkNight border-white">
                <div className="w-7 h-7 rounded-full">
                  <img
                    className="rounded-full w-full h-full"
                    alt="user1"
                    // src={avatar}
                    src="https://diamondapp.com/api/v0/get-single-profile-picture/BC1YLftoYzDAMK8fmHF3q8Vyeh6uX8sAYUk4PW12VxbpZ8bny5GvNe6" loading="lazy"
                  />
                </div>
              </div> */}
            </div>
            {item.online_users_count > 0 && (
              <div className="text-darkGray">
                {item.online_users_count} talking
              </div>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
}

export default PopularRoomCard;
